import React, { useEffect, useState } from "react";
import {
  Typography,
  TextField,
  FormControl,
  Box,
  Button,
  Tabs,
  Tab,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Autocomplete,
  MenuItem,
  Chip,
  Menu,
  Tooltip
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { updateCustomer } from "../../redux/Slice/customerSlice";
import { createPlan, fetchPlan, updatePlan } from "../../redux/Slice/planslice";
import { toast } from "sonner";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { fetchCustomerByid } from "../../redux/Slice/customerSlice";
import { getQuoteByServiceId } from "../../redux/Slice/quoteSlice";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { clearMessage } from "../../redux/Slice/message";
import { fetchTags } from "../../redux/Slice/showcase/tagSlice";
import { fetchService } from "../../redux/Slice/serviceslice";
import { fetchProductTemplates } from "../../redux/Slice/ProductTemplate";
import { fetchInspirationTemplates } from "../../redux/Slice/InspirationTemplate";
import CancelIcon from "@mui/icons-material/Cancel";
import IconButton from "@mui/material/IconButton";
import AddIcon from '@mui/icons-material/Add';
import ConfirmDialog from '../../components/dialog/dialog'; 



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PlanEdit = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { customerDetail: customer, loading } = useSelector((state) => state.customer);
  const { quotes } = useSelector((state) => state.quote);
  const [editablePlans, setEditablePlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [tabValues, setTabValues] = useState({}); // Track tab values for each plan
  const [newServices, setNewServices] = useState([]);
  const message = useSelector((state) => state.message);

  const { tags } = useSelector((state) => state.tag);

  const { services: serv } = useSelector((state) => state.service);
  const { Producttemplates } = useSelector((state) => state.productTemplate);
  const { Inspirationtemplates } = useSelector((state) => state.inspirationTemplate);

  const templateOptions = quotes?.filter((quote) => quote.status);
  const templateProduct = Producttemplates?.filter((temp) => temp.status);
  const templateInspiration = Inspirationtemplates?.filter((inspiration) => inspiration.status);


  useEffect(() => {
    if (message?.message) {
      toast(message.message);
      dispatch(clearMessage());
    }
  }, [message, dispatch]);

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(fetchCustomerByid({ c_id: id }));
    dispatch(fetchService());
    dispatch(fetchTags());
    dispatch(fetchProductTemplates());
    dispatch(fetchInspirationTemplates())
      .finally(() => {
        dispatch(setLoading(false));
      });
  }, [dispatch, id]);

  useEffect(() => {
    if (customer?.plans) {
      const normalizedPlans = customer.plans.map((plan) => ({
        ...plan,
        services: plan.services.map((service) => ({
          ...service,
          template: service.template?.map((tpl) => tpl._id) || [],
        })),
        showcaseTemplate: plan.showcaseTemplate?.map((tpl) => (tpl._id ? tpl._id : null)) || [],
        productTemplate: plan.productTemplate?.map((tpl) => (tpl._id ? tpl._id : null)) || [],
        inspirationTemplate: plan.inspirationTemplate?.map((tpl) => (tpl._id ? tpl._id : null)) || [],
      }));
      setEditablePlans(normalizedPlans);
    }
  }, [customer]);

  const handlePlanChange = (planId, field, value) => {
    const updatedPlans = editablePlans.map((plan) =>
      plan._id === planId ? { ...plan, [field]: value } : plan
    );
    setEditablePlans(updatedPlans);
  };

  const handleTabChange = (planId, newValue) => {
    setTabValues((prev) => ({ ...prev, [planId]: newValue }));

    const serviceId = editablePlans.find((plans) => plans._id === planId)?.services[newValue]?.serviceId;
    if (serviceId._id) {
      dispatch(getQuoteByServiceId({ q_id: serviceId._id }));
    }
  };

  const handleServiceChange = (planId, serviceIndex, featureIndex, value) => {
    const updatedPlans = editablePlans.map((plan) => {
      if (plan._id === planId) {
        const updatedServices = plan.services.map((service, sIndex) => {
          if (sIndex === serviceIndex) {
            const updatedFeatures = service.features.map((feature, fIndex) =>
              fIndex === featureIndex ? { ...feature, value } : feature
            );
            return { ...service, features: updatedFeatures };
          }
          return service;
        });
        return { ...plan, services: updatedServices };
      }
      return plan;
    });
    setEditablePlans(updatedPlans);
  };

  const handleTemplateChange = (planId, serviceId, newTemplates) => {
    const updatedPlans = editablePlans.map((plan) => {
      if (plan._id === planId) {
        const updatedServices = plan.services.map((service) => {
          if (service.serviceId._id ===serviceId ) {
            console.log("serv",service._id)
            return { ...service, template: newTemplates.map((tpl) => tpl._id) };
          }
          return {...service};
        });
        return { ...plan, services: updatedServices };
      }
      return {...plan};
    });
    setEditablePlans(updatedPlans);
  };

  const handleAddService = (planId, newService) => {
    const updatedPlans = editablePlans.map((plan) => {
      if (plan._id === planId) {
        return {
          ...plan,
          services: [...plan.services, newService],
        };
      }
      
      return plan;
    });
    // console.log("plan:",updatedPlans)
    setEditablePlans(updatedPlans);
  };

  const handleSave = () => {
    if (!selectedPlanId) return;

    dispatch(setLoading(true));
    const selectedPlan = editablePlans.find((plan) => plan._id === selectedPlanId);
    console.log("selectedplan:",selectedPlan)
    const transformedPlan = {
      ...selectedPlan,
      services: selectedPlan.services.map((service) => ({
        ...service,
        serviceId: service.serviceId._id ,
      })),
    };

    // console.log("trensform:",transformedPlan)

    dispatch(updatePlan({ id: transformedPlan._id, formData: transformedPlan }))
    .unwrap()
  .then(() => {
    setSelectedPlanId(null); 
  })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const getAvailableServices = (planId) => {
    const plan = editablePlans.find((plan) => plan._id === planId);
    const usedServiceIds = plan?.services.map((service) => service.serviceId._id) || [];
    return serv.filter((service) => !usedServiceIds.includes(service._id));
  };

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    planId: null,
    serviceIndex: null,
  });
   
  const handleConfirmRemoveService = () => {
    const { planId, serviceIndex } = confirmDialog;
    if (planId !== null && serviceIndex !== null) {
      setEditablePlans((prevPlans) =>
        prevPlans.map((plan) =>
          plan._id === planId
            ? { ...plan, services: plan.services.filter((e, index) => index !== serviceIndex) }
            : plan
        )
      );
    }
    setConfirmDialog({ isOpen: false, planId: null, serviceIndex: null });
  };
  


  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedService, setSelectedService] = useState(null);

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectService = (planId,newValue) => {
    if (newValue) {
      const features = newValue.features || [];
      const templates = templateOptions.filter(option =>
        (serv.find(bc => bc.serviceId === newValue._id)?.template || []).includes(option._id)
      );

      const newService = {
        serviceId: newValue,
        features: features,
        template: templates,
      };

      handleAddService(planId, newService);
      setSelectedService(newValue);
    }
    closeMenu();
  };
  

  if (loading) return <Typography> Loading...</Typography>;
  if (!customer || !editablePlans.length) return <Typography>No plans found for this customer.</Typography>;

  const { companyName } = customer;

  return (
    <Grid container spacing={2} >
      <Grid item size={12}>
        <Typography variant="h4" gutterBottom>
          Edit Plan Details for {companyName}
        </Typography>
      </Grid>

      {/* <Grid item size={12}>
        <FormControl fullWidth margin="normal">
          <Typography variant="subtitle1">Customer</Typography>
          <TextField value={companyName} slotProps={{ input: { readOnly: true } }} sx={{ width: "50%" }} />
        </FormControl>
      </Grid> */}

      {editablePlans.map((plan) => {
        const { _id: planId, name, price, expiredDays, services, showcaseTemplate,productTemplate, inspirationTemplate  } = plan;
        const isEditable = planId === selectedPlanId;

        return (
          <React.Fragment key={planId}>
              {/* <Box sx={{ padding: "20px", border: "1px solid #ddd", borderRadius: 2 }}> */}

            <Grid container sx={{padding: "20px", border: "1px solid #ddd", borderRadius: 2 }} spacing={2}>
              <Grid item size={12} >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography variant="h4">Plan: {name}</Typography>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => setSelectedPlanId(isEditable ? null : planId)}
                  >
                    {isEditable ? "Cancel Edit" : "Edit This Plan"}
                  </Button>
                </Box>
              </Grid>

              <Grid item size={4}>
                <FormControl fullWidth margin="normal">
                  <Typography variant="subtitle1">Plan Name</Typography>
                  <TextField
                    value={name}
                    onChange={(e) => handlePlanChange(planId, "name", e.target.value)}
                    fullWidth
                    disabled={!isEditable}
                  />
                </FormControl>
              </Grid>

              <Grid item size={4}>
                <FormControl fullWidth margin="normal">
                  <Typography variant="subtitle1">Plan Price</Typography>
                  <TextField
                    value={price}
                    onChange={(e) => handlePlanChange(planId, "price", e.target.value)}
                    fullWidth
                    disabled={!isEditable}
                  />
                </FormControl>
              </Grid>

              <Grid item size={4}>
                <FormControl fullWidth margin="normal">
                  <Typography variant="subtitle1">Expiry Day</Typography>
                  <TextField
                    value={expiredDays}
                    onChange={(e) => handlePlanChange(planId, "expiredDays", Number(e.target.value))}
                    fullWidth
                    disabled={!isEditable}
                  />
                </FormControl>
              </Grid>
        
    
 
              <Grid item size={10}>
              <Tooltip title="Click to edit the services" arrow>
        <Typography variant="h6" sx={{ cursor: 'pointer' }}>
          Services
        </Typography>
      </Tooltip>
                <Tabs
                  value={tabValues[planId] ?? null}
                  onChange={(e, newValue) => handleTabChange(planId, newValue)}
                  variant="scrollable"
                  scrollButtons="auto"
                  disabled={selectedPlanId && selectedPlanId !== planId}
                >
                  {services.map((service, index) => (
 <Tab
 key={index}
 label={
   <Box sx={{ display: "flex", alignItems: "center" }}>
     {service.serviceId.name}
     {isEditable && (
       <IconButton
       size="small"
       onClick={(e) => {
         e.stopPropagation();
         setConfirmDialog({
           isOpen: true,
           planId,
           serviceIndex: index,
         });
       }}
       disableRipple
       sx={{ p: 0, border: "none" }}
     >
       <CancelIcon fontSize="small" />
     </IconButton>
     
     )}
   </Box>
 }
 disabled={selectedPlanId && selectedPlanId !== planId}
/>                  ))} 
                </Tabs>


                
            
                {services.map((service, serviceIndex) => (
                  <Box key={serviceIndex} hidden={(tabValues[planId]) !== serviceIndex}>
                    <Grid container spacing={2}>
                      <Grid item size={6}>
                        <Box display="flex" flexDirection="column" gap={2} padding={2} sx={{ border: "1px solid #ddd", borderRadius: 2 }}>
                          <Typography variant="h6">Features</Typography>
                          {service.features.map((feature, featureIndex) => (
                            <Box key={featureIndex} display="flex" alignItems="center" gap={1}>
                              <Typography width={"60%"} variant="body1">
                                {feature.key}:
                              </Typography>
                              <TextField
                                variant="outlined"
                                size="small"
                                value={feature.value || ""}
                                onChange={(e) => handleServiceChange(planId, serviceIndex, featureIndex, e.target.value)}
                                style={{ flex: 1 }}
                                disabled={!isEditable}
                              />
                            </Box>
                          ))}
                        </Box>
                      </Grid>
                      <Grid item size={6}>
                        <Box padding={2} sx={{ border: "1px solid #ddd", borderRadius: 2 }}>
                          <Typography variant="h6">Select Templates</Typography>
                          <Autocomplete
                            multiple
                            options={templateOptions}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.templateName}
                            value={templateOptions.filter((option) => service.template.includes(option._id))}
                            onChange={(e, newValue) => handleTemplateChange(planId, service.serviceId._id, newValue)}
                            renderOption={(props, option, { selected }) => (
                              <li {...props}>
                                <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                                {option.templateName}
                              </li>
                            )}
                            renderInput={(params) => <TextField {...params} placeholder="Select Template" />}
                            disabled={!isEditable}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                ))}
              </Grid>

      <Grid item size={2} sx={{ mb: 4, mt: 3 }}>
      <Button
        onClick={openMenu}
        disabled={!isEditable}
        startIcon={<AddIcon />} 
      >
        Select Service
      </Button>
    <Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={closeMenu}
>
  {selectedPlanId &&
    getAvailableServices(selectedPlanId).map((service) => (
      <MenuItem key={service._id} onClick={() => handleSelectService(selectedPlanId, service)}>
        {service.name}
      </MenuItem>
    ))}
</Menu>

    </Grid>

              {/* <TemplateSelector
        label="Showcase Templates"
        options={tags}
        selectedOptions={showcaseTemplate}
        onChange={(updated) => handlePlanChange(planId, "showcaseTemplate", updated)}
        isEditable={isEditable}
      /> */}
      <TemplateSelector
        label="Product Templates"
        options={templateProduct}
        selectedOptions={productTemplate}
        onChange={(updated) => handlePlanChange(planId, "productTemplate", updated)}
        isEditable={isEditable}
      />
      <TemplateSelector
        label="Inspiration Templates"
        options={templateInspiration}
        selectedOptions={inspirationTemplate}
        onChange={(updated) => handlePlanChange(planId, "inspirationTemplate", updated)}
        isEditable={isEditable}
      />

              {isEditable && (
                <Grid item size={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                  <Button
                    variant="outlined"
                    onClick={() => setSelectedPlanId(isEditable ? null : planId)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                  >
                    Save Plan
                  </Button>
                </Grid>
              )}

            </Grid>
          </React.Fragment>
        );
      })}

<ConfirmDialog
  open={confirmDialog.isOpen}
  message="Are you sure you want to remove this service?"
  onClose={() => setConfirmDialog({ isOpen: false, planId: null, serviceIndex: null })}
  onConfirm={handleConfirmRemoveService}
/>
    </Grid>
  );
};


const TemplateSelector = ({ label, options, selectedOptions, onChange, isEditable }) => {
  return (
    <Grid item size={4} sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{mb:2}}>{label}</Typography>
      <TextField
        select
        fullWidth
        variant="outlined"
        // label={`Select ${label}`}
        placeholder={`Select ${label}`}
        disabled={!isEditable}
        onChange={(e) => {
          const value = e.target.value;
          if (!selectedOptions.includes(value)) {
            onChange([...selectedOptions, value]);
          }
        }}
      >
        {options
        .filter((option) => !selectedOptions.includes(option._id))
        .map((option) => (
          <MenuItem key={option._id} value={option._id}>
            {option.name || option.templateName}
          </MenuItem>
        ))}
      </TextField>
      <Box sx={{ marginY: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
        {selectedOptions.map((id) => {
          const selectedOption = options.find((opt) => opt._id === id);
          return (
            <Chip
              key={id}
              label={selectedOption?.name || selectedOption?.templateName}
              onDelete={
                isEditable
                  ? () => onChange(selectedOptions.filter((tplId) => tplId !== id))
                  : undefined
              }
            />
          );
        })}
      </Box>
    </Grid>
  );
};

export default PlanEdit;